<template>
  <div id="app" name="fade">  
      <transition name="fade">
        <keep-alive>
           <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
       </transition>
     <transition name="fade"><router-view v-if="!$route.meta.keepAlive"></router-view></transition>
  </div>
</template>

<script>
//import './assets/css/reset.css'
export default {
  name: 'App'
}
</script>

<style>
#app{
  height: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0
}


</style>



// WEBPACK FOOTER //
// src/App.vue